import { DAY_END_MIN, DAY_START_MIN, PX_PER_MIN, minutesToHHMM } from '@skolveckan/shared';

interface Props {
  nowMin: number;
  /** Klockslagschippet visas bara i dagsvyn, inte i varje veckokolumn. */
  showLabel?: boolean;
}

/**
 * Den enda röda linjen i gränssnittet. Att den är ensam om färgen är vad som
 * gör att den syns trots att åtta ämnen har varsin färg omkring sig.
 */
export function NowLine({ nowMin, showLabel = true }: Props) {
  if (nowMin < DAY_START_MIN || nowMin > DAY_END_MIN) return null;
  const top = (nowMin - DAY_START_MIN) * PX_PER_MIN;

  return (
    <>
      <div className="nowline" style={{ top }} aria-hidden="true" />
      <div className="nowline__dot" style={{ top: top - 5 }} aria-hidden="true" />
      {showLabel && (
        <div className="nowline__chip" style={{ top: top - 8 }}>
          {minutesToHHMM(nowMin)}
        </div>
      )}
    </>
  );
}
